module Meevo.Plugins.DrawerManager {
    import RegisterActionPromptResponseEnum = Meevo.Plugins.Register.RegisterActionPromptResponseEnum;
    import RegisterSectionCatTypeEnum = Meevo.Plugins.Register.RegisterSectionCatTypeEnum;
    import RegisterSectionTypeEnum = Meevo.Plugins.Register.RegisterSectionTypeEnum;
    "use strict";

    export class OpeningDrawerSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {
    
        private isEditing: boolean; 

        constructor(drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.OpeningDrawer, drawerManagerContext, "openingDrawer", personalHeader, personalFooter);
        }

        reset() {
            super.reset();

            this.isEditing = this.context.editingOpeningCash;
        }

        cloneDrawerSession(drawerSession: Meevo.Model.DrawerSession): Meevo.Model.PatchDrawerSession {
            var newDS: Meevo.Model.PatchDrawerSession = _.clone<Meevo.Model.DrawerSession>(drawerSession);
            return newDS;
        }

        cancel() {
            this.context.editingOpeningCash = false;
            this.context.isOpeningClosingDrawer = false;
            this.context.closeSection();
        }

        save() {
            if (this.isEditing) {
                let patchSession = this.cloneDrawerSession(this.context.selectedDrawer.drawerSession);
                patchSession.openCashAmount = this.context.selectedDrawer.drawerSession.actualCashInDrawer;
                patchSession.cashLeftInDrawer = this.context.selectedDrawer.drawerSession.closeCashAmount;
                let cashTrans = _.findWhere(patchSession.aggregatedPaymentTransactions, { paymentCategory: Meevo.Model.PaymentCategoryEnum.Cash });
                if (cashTrans) {
                    patchSession.actualCashInDrawer = cashTrans.actualAmount;
                }
                patchSession.updateState = Meevo.Model.DrawerStateEnum.Open;

                this.context.patchDrawerSession(patchSession)
                    .then(() => {
                        this.context.editingOpeningCash = false;
                        this.context.closeSection();
                        this.context.isOpeningClosingDrawer = false;
                    });
            }
            else {
                this.context.createDrawerSession()
                    .then(() => {
                        if (this.context.insideRegister) {
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_OPENED, { name: "register" });
                        }
                        this.context.replaceOpenSection(DrawerManagerSectionTypeEnum.DrawerOpened, DrawerManagerSectionTypeEnum.DrawerClosed);
                    });
            }
        }

        getSectionName() {
            let sectionName: string = "";
            if (this.isEditing) {
                sectionName = this.context.selectedDrawer.displayName + " - Edit Opening Cash";
            }
            else {
                sectionName = this.context.selectedDrawer.displayName + " - Opening";
            }
            return sectionName;
        }
    }

}